import type { Translation } from "~/types/i18n";

export const ja: Translation = {
  nav: {
    top: "TOP",
    pv: "PV",
    introduction: "INTRODUCTION",
    character: "CHARACTER",
    news: "NEWS",
    goods: "GOODS",
    onair: "ON AIR",
    special: "SPECIAL",
  },
  hero: {
    comingSoon: "放送・配信情報 近日公開",
    scrollDown: "SCROLL",
  },
  pv: {
    title: "PV",
    subtitle: "プロモーションビデオ",
  },
  synopsis: {
    title: "STORY",
    subtitle: "あらすじ",
  },
  characters: {
    title: "CHARACTER",
    subtitle: "キャラクター紹介",
    cv: "声優",
  },
  news: {
    title: "NEWS",
    subtitle: "最新情報",
    new: "NEW",
    noNews: "ニュースはありません",
  },
  md: {
    title: "MD",
    subtitle: "公式グッズ",
    visitStore: "ストアへ",
    goBack: "戻る",
    viewDetail: "詳しく見る",
    buyNow: "購入する",
  },
  onair: {
    title: "ON AIR",
    subtitle: "放送情報",
  },
  special: {
    title: "SPECIAL",
    subtitle: "スペシャルコンテンツ",
  },
  footer: {
    policy: "プライバシーポリシー",
    originals: "Laftel Originals",
    contact: "お問い合わせ",
    share: "Xでシェア",
    copyright: "© 2025 Laftel Inc. All Rights Reserved.",
  },
  cta: {
    comingSoon: "準備中",
  },
  home: {
    heroSubtitle: "ラフテルが手がけるオリジナルアニメーション",
    aboutTitle: "すべてのアニメファンの毎日を、豊かに",
    aboutDescription:
      "LaftelはサブカルチャーIPを基軸に、\nアニメーションの制作・投資からグッズ、オフライン事業までを\n幅広く展開し、アニメ文化の多様性を広げています。\nLaftelオリジナルが見出す素晴らしい物語を通じて、\n新しいコンテンツの世界を心ゆくまでお楽しみください。",
    worksTitle: "オリジナル作品",
    comingSoon: "COMING SOON",
    navAbout: "ABOUT",
    navWorks: "WORKS",
    watchOnYoutube: "YouTubeで見る",
  },
};
